import React, { useState, useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const handleChange = (e, changeFunction, data) => {
  changeFunction(data[e.target.selectedIndex].descricao);
};

const handleDoubleClick = (e, doubleClickFunction, data) => {
  doubleClickFunction(data[e.target.index].campo);
};

const ListBoxCamposAtividadePadrao = ({ formik, field, disabled, onChange, onDoubleClick }) => {
  const [camposAtividadePadrao, setCamposAtividadePadrao] = useState([]);
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    request(apiRoutes.fiscalizacao.parametrizacao.consultaCamposAtividadePadrao);
  }, [request]);

  useEffect(() => {
    if (data) setCamposAtividadePadrao(data.result);

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  return (
    <>
      {showErro ? (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      ) : null}
      {isLoading ? (
        <span>
          <Spinner animation="border" role="status" />
          &nbsp;Carregando ...
        </span>
      ) : (
        <>
          <Form.Control
            as="select"
            id={field}
            htmlSize="20"
            name={field}
            disabled={disabled}
            value={formik.values[field]}
            onChange={(e) => handleChange(e, onChange, camposAtividadePadrao)}
            onDoubleClick={(e) => handleDoubleClick(e, onDoubleClick, camposAtividadePadrao)}
            isInvalid={formik.touched[field] && formik.errors[field]}
          >
            {camposAtividadePadrao.map((item) => (
              <option key={item.codigo} value={item.codigo}>
                {item.campo}
              </option>
            ))}
          </Form.Control>
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      )}
    </>
  );
};

export default ListBoxCamposAtividadePadrao;
